  <template>
    <div class="mt-5">
      <div class="wrap mt-5">
        <div class="d-flex flex-column align-items-center cards" style="max-width:1000px">
          <h4 class="tit1 text-primary mr-0 text-center">測試簽名</h4>
          <div class="row inputWrap">
            <div class="col-12 d-flex liss border-b">
              <h6 class="text-right d-flex flex-wrap-wrap h6T align-items-center">
                <p class="text-primary">商戶密鑰</p>
                <input type="text" placeholder="商戶密鑰" v-model="api_key">
              </h6>
            </div>
            <div class="col-12  liss border-b">
              <h6 class="text-right d-flex flex-wrap-wrap h6T align-items-center">
                <p class="text-primary">傳送的JSON</p>
                <textarea style="color:black" cols="30" rows="10" placeholder="傳送的JSON" v-model="json_str"></textarea>
              </h6>
            </div>
            <div class="d-flex justify-content-center w-100 mt-2">
              <div class="text-white" v-html="modalStr"></div>
              </div>
            </div>
          </div>
          <button class="btn send mt-4" @click="send">送出</button>
        </div>
      </div>
    <!-- </div> -->
    </template>
  <style lang="scss" scoped>
  .allWrap {
    justify-content: center;
  }
  
  .send {
    width: 200px;
    height: 40px;
    background-color: #0f73eb;
    color: white
  }
  
  .imgWrap {
    display: flex;
    flex-direction: column;
  
    img {
      max-width: 1000px;
      width: 100%;
    }
  }
  
  body {
    background-color: #ebeff0 !important;
  }
  
  .wrap {
    font-family: 新細明體 !important;
    width: 100%;
    min-height: 90vh;
    border-radius: 10px;
    align-items: center;
    display: flex;
    justify-content: center;
  }
  
  p {
    color: black;
    font-size: 16px;
    word-break: break-all;
  }
  
  .cards {
    width: 100%;
    background-color: #fff;
    display: block;
    padding: 30px 50px;
    border-radius: 10px;
    margin-bottom: 30px;
  }
  
  .liss:nth-child(even) {
    // justify-content: flex-end;
  }
  
  .liss:nth-child(even) {
    justify-content: flex-start !important;
  
    h6 {
      // justify-content: space-between !important;
      width: 100%;
      flex-direction: row !important;
      align-items: center;
    }
  }
  
  .h6T {
    // justify-content: space-between !important;
    width: 100%;
  
    // flex-direction: column;
    p {
      // text-align: left;
      margin-bottom: 0;
    }
  }
  
  @media (max-width: 768px) {
    .liss:nth-child(even) {
      justify-content: flex-start !important;
  
      h6 {
        justify-content: space-between !important;
        width: 100%;
        flex-direction: row !important;
      }
    }
  
    .h6T {
      justify-content: space-between !important;
      width: 100%;
  
      // flex-direction: column;
      p {
        // text-align: left;
        margin-bottom: 0;
      }
    }
  
    .cards {
      padding: 20px;
    }
  }
  
  .tit1 {
    margin-bottom: 30px;
    border-bottom: 3px solid #007bff;
    padding-bottom: 20px;
  }
  
  h6 {
    // line-height: 2;
  }
  
  .inputWrap {
    // border-top: 3px solid #ccc;
    // border-bottom: 3px solid #ccc;
  }
  
  .border-b {
    width: 100%;
    border-bottom: 1px solid #ccc;
  
    p {
      &:first-child {
        min-width: 200px;
        text-align: left;
      }
    }
  }
  
  .btn {
    padding: 5px;
    border-radius: 5px;
    min-width: 80px;
    color: white;
    background-color: #4669e7;
    float: right;
    margin-bottom: 5px;
  
    &:hover {
      color: white;
    }
  }
  
  .lanWrap {
    display: flex;
    justify-content: flex-end;
  
    .lanBox {
      padding: 3px 5px;
      border: 1px solid black;
      border-radius: 3px;
      margin-left: 5px;
      margin-right: 5px;
      cursor: pointer;
  
      &.active {
        color: white;
        background-color: #4669e7;
        border: 1px solid gray;
      }
    }
  }
  
  .t1 {
    text-align: center;
  }
  
  .t2 {
    text-align: right;
  }
  
  @media (max-width: 500px) {
    .t1 {
      text-align: left;
    }
  
    .t2 {
      text-align: center;
    }
  
    .tit1 {
      font-size: 24px;
    }
  
    .border-b {
      flex-wrap: wrap;
  
      p {
        &:first-child {
          width: 150px;
        }
      }
  
      p {
        &:last-child {
          padding-left: 0 !important;
        }
      }
    }
  }
  
  @media (max-width: 400px) {
    .t1 {
      text-align: left;
    }
  
    .t2 {
      text-align: center;
    }
  
    .tit1 {
      font-size: 24px;
    }
  
    .border-b {
      flex-wrap: wrap;
  
      p {
        &:first-child {
          width: 100px;
        }
      }
  
      p {
        &:last-child {
          padding-left: 0 !important;
        }
      }
    }
  }
  
  .noQrcode {
    width: 150px;
    margin-top: -20px;
  }
  
  input {
    width: 245px;
    height: 40px;
    padding: 10px;
    border-color: #e6e6e6;
    border-width: 2px;
    appearance: none;
    outline: none;
  
    &:focus {
      border-color: #0f73eb;
    }
  }
  
  .rightCC {
    // padding-top: 10px;
    // padding-bottom: 10px;
  }
  
  .liss {
    padding-top: 20px;
    padding-bottom: 20px;
    min-height: 75px;
    align-items: center;
  }
  
  .payWrap {
    display: flex;
    flex-wrap: wrap;
    // justify-content: flex-end;
  }
  
  .pay {
    margin-right: 10px;
    font-size: 14px;
    width: 200px;
    height: 100px;
    border: 1px solid #e6e6e6;
    padding: 15px;
    margin-bottom: 10px;
    cursor: pointer;
  
    &.active {
      border-color: #0f73eb;
    }
  }
  </style>
  <script>
  export default {
    data() {
      return {
        json_str: "",
        api_key: "",
        sign_mode: "2",
        modalStr:"",
        modal:false
      }
    },
    methods: {
      send() {
        console.log(this.json_str)
        try {
          if(typeof(JSON.parse((this.json_str)))!= 'object') {
            alert('請輸入正確的JSON');
            return
          }
        } catch {
          alert('請輸入正確的JSON');
          return
        }
        this.$http.post(`/ccc/sign_check`, {
          json_str: this.json_str,
          api_key: this.api_key,
          sign_mode: this.sign_mode
        }).then(res=>{
          this.modal = true;
          this.modalStr = res.data
        })
      }
    },
    created() {
    }
  }
  </script>
  
  <style lang="scss" scoped>
  textarea {
    background-color: transparent;
    width: 100%;
    padding: 10px;
    color:white
  }
  
  select {
    background-color: transparent;
    height: 56px;
    padding: 0 20px;
    color: white;
    width: 100%;
  }
  .resContent {
    word-break: break-all;
    text-align-last: left;
  }
  pre {
    word-break: break-all;
    width: 100%;
    height: 500px;
  }
  </style>
  